<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LckwBI/tc-custom/9780830899685.jpg?1696025822086" alt="This image is the cover for the book The Myth of the Non-Christian"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Myth of the Non-Christian
      </h1>
      <p class="bookDescription body article font2">
        <p>There's no such thing as a non-Christian. Somebody might self-identify as spiritual but not religious. Or they might be a practicing Hindu, Buddhist or Muslim. Or they might call themselves an atheist, freethinker or agnostic. But the one thing that people never describe themselves as is a "non-Christian." So Christians who want to "reach non-Christians" need to realize that they're not all the same. Evangelism is not one-size-fits-all. Luke Cawley shows how Christians can contextualize the gospel in different ways to connect with different kinds of people. Here he unpacks the religious identities of three key demographics: the spiritual but not religious, committed atheists and nominal Christians. Each group has particular characteristics and requires specific approaches and practices to make the Christian faith plausible, desirable and tangible to them. Filled with real-life stories of changed lives, this book is a practical and hopeful resource for helping people to encounter God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Luke Cawley
      </h2>
      
      <p class="authorDescription body article"><p>Luke Cawley is a writer, speaker, trainer and the director of Chrysolis, an organization he helped start in 2012 with a vision to enable organizations and churches to better communicate the Jesus story. Luke has spent most of his adult life founding and developing missional communities on university campuses in Britain and Romania and is a regular speaker at conferences and outreach events around the world. An active writer and blogger, Luke has trained people at churches, parachurch organizations and universities to better engage those around them with the story of Jesus. He enjoys thoughtful engagement with people who wouldn't normally consider Jesus and he often speaks in contexts where God is not typically discussed, such as schools, bars, cafes and theatres. Luke has an master's degree in evangelism and leadership from Wheaton College and a certificate in theological and pastoral studies from Oxford University. He's married to Whitney, a schoolteacher, and they have three children.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ce402ee